import React, { useContext } from "react";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useState, useEffect } from "react";
import Global from "../util/Global";
import { AlertContext } from "../util/Alerter";
import { LoaderComponent } from "../util/Loader";
import AdsFilter from "../components/Ads/AdsComponents";
import AdsComponent from "../components/Ads/AdsComponent";
import { GlobalData } from "../util/GlobalData";
import { DeliveryCountryContext } from "../components/Utils";



export default function Ads() {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const { countries } = useContext(DeliveryCountryContext)

  const [filteredList, setFilteredList] = useState([]);
  const [adsList, setadsList] = useState([]);
  const [isLoading, setisLoading] = useState(true)

  const ADS_URL = Global.backend + "/index.php/allAds";


  useEffect(() => {
    setisLoading(true)

    axios.all([ axios.get(ADS_URL)])
      .then(axios.spread(( adsResponse) => {


        setadsList(adsResponse.data.filter(ad => ad.etat == 1));
      })).catch((err) => {
        showAlert("error", t("request.errorFetchingAdsDetails"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, []);








  return (
    <div>
      <LoaderComponent isLoading={isLoading}>
        <main
          className="my-main ttm-bgcolor-grey"
          style={{
            minHeight: "calc(100vh + 700px)",
          }}
        >
          <div className="container-fluid bg-trasparent my-4 p-3">
            <div className="row">
              <AdsFilter title={t("navigation7.1")} adsList={adsList} setFilteredList={setFilteredList} categories={GlobalData.ads.categories} pays={countries} />

              <div className="col-md-9">
                <div className="container-fluid">
                  <AdsComponent itemsPerPage={8} items={filteredList} />
                </div>
              </div>
            </div>
          </div>


        </main>
      </LoaderComponent>
      <Footer />
    </div>
  );
}